import { useTranslation } from 'react-i18next'

import translationKeys from '@translationKeys'

import { POneEvent } from '@modules/auth/hooks/types'
import { Button } from '@mui/material'
import { useFeatureFlags } from '@shared/hooks/useFeatureFlags'

import DelegatesSection from './DelegatesSection'
import { SectionsListWrapper, ViewMoreSection } from './index.styles'

interface DelegateSectionsListProps {
  eventsList?: POneEvent[]
  companyId?: number
  onViewMoreClick: () => void
  allSectionsDisplayed: boolean
}

const DelegateSectionsList = ({
  eventsList = [],
  companyId,
  onViewMoreClick,
  allSectionsDisplayed,
}: DelegateSectionsListProps) => {
  const { t } = useTranslation()
  const { hasAccessToChat } = useFeatureFlags()

  return (
    <SectionsListWrapper>
      {eventsList.map(event => (
        <DelegatesSection key={event.id} event={event} companyId={companyId} showContactBtn={hasAccessToChat} />
      ))}
      {!allSectionsDisplayed ? (
        <ViewMoreSection>
          <Button variant="contained" onClick={onViewMoreClick} id="all_delegates-view_more_events">
            {t(translationKeys.VIEW_MORE_EVENTS)}
          </Button>
        </ViewMoreSection>
      ) : null}
    </SectionsListWrapper>
  )
}

export default DelegateSectionsList
